import { v4 as uuidv4, v7 as uuidv7 } from 'uuid';

export const TRACE_ID_HEADER = 'X-Flox-Trace-Id';
export const SESSION_ID_HEADER = 'X-Flox-Session-Id';
export const USER_ID_HEADER = 'X-Flox-User-Id';
export const BUSINESS_ID_HEADER = 'X-Flox-Business-Id';

const SESSION_ID_STORAGE_KEY = 'flox.observability.sessionId';

export function generateTraceId(): string {
  try {
    return uuidv7();
  } catch {
    return uuidv4();
  }
}

export function getOrCreateSessionId(): string {
  try {
    const existing = window.sessionStorage.getItem(SESSION_ID_STORAGE_KEY);
    if (existing) return existing;
    const fresh = uuidv4();
    window.sessionStorage.setItem(SESSION_ID_STORAGE_KEY, fresh);
    return fresh;
  } catch {
    return uuidv4();
  }
}
